import create from 'zustand';

// AIDEV-NOTE: Module-level cursor for "the slideshow + slide the student is currently
// viewing in PresentMode." Lives outside SlideShowStoreProvider so layout-level components
// and Rails-mounted React islands (e.g. StudentSessionListener, the Drawing-question modal)
// can subscribe to slide changes from outside the React tree. PresentMode writes both ids on
// mount/slide-change and clears them on unmount; everywhere else only reads.
interface CurrentSlideShowStore {
  currentSlideId: number | null;
  currentSlideShowId: number | null;
  setCurrentSlideId: (id: number | null) => void;
  setCurrentSlideShowId: (id: number | null) => void;
}

const useCurrentSlideShowStore = create<CurrentSlideShowStore>(set => ({
  currentSlideId: null,
  currentSlideShowId: null,
  setCurrentSlideId: id => set({ currentSlideId: id }),
  setCurrentSlideShowId: id => set({ currentSlideShowId: id }),
}));

export default useCurrentSlideShowStore;
